/**
 * Describes the different states a Nursing-Task-Documentation can possess.
 */
export enum TaskDocumentationState {
  /**
   * The Task is still open (i.e. has yet to be completed)
   */
  OPEN = 'OPEN',
  /**
   * The Task has been completed successfully as planned.
   */
  DONE = 'DONE',
  /**
   * The Task has been completed but not as planned (e.g. at another point of time)
   */
  DEVIATION = 'DEVIATION',
  /**
   * The Task could not be completed and has been postponed to the next day
   */
  POSTPONED = 'POSTPONED',
  /**
   * The Task could not be completed and has been postponed to the next scheduled day based on the task occurence
   */
  POSTPONEDSCHEDULED = 'POSTPONEDSCHEDULED',
  /**
   * The Task could not be completed at all and hence failed.
   */
  FAILED = 'FAILED',
}
